import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Carousel,
  Navbar,
  Nav,
  Badge,
  NavDropdown,
} from "react-bootstrap";
import {
  FaQuoteLeft,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaEnvelope,
  FaUser,
  FaUserShield,
  FaCheckCircle,
  FaTags,
  FaStar,
  FaBoxes,
  FaChevronDown,
} from "react-icons/fa";
import { useState, useEffect } from "react";
import "../App.css";
import {
  FaFileInvoiceDollar,
  FaBook,
  FaGem,
  FaUsers,
  FaBaby,
  FaPhoneAlt,
} from "react-icons/fa";
import {
  GiStarsStack,
  GiBookCover,
  GiCrystalBall,
  GiNotebook,
  GiAries,
  GiTaurus,
  GiGemini,
  GiCancer,
  GiLeo,
  GiVirgo,
  GiLibra,
  GiScorpio,
  GiSagittarius,
  GiCapricorn,
  GiAquarius,
  GiPisces,
} from "react-icons/gi";
import { motion } from "framer-motion";
import "./css/home.css";
import useTitle from "../hooks/useTitle";

const products = [
  {
    name: "Finance Report",
    icon: <FaFileInvoiceDollar size={50} color="#FFF" />,
  },
  { name: "Cosmic Code", icon: <GiStarsStack size={50} color="#FFF" /> },
  { name: "Lal Kitab Report", icon: <GiBookCover size={50} color="#FFF" /> },
  {
    name: "Fortune Plus Report",
    icon: <GiCrystalBall size={50} color="#FFF" />,
  },
  {
    name: "Book Consultation Call",
    icon: <FaPhoneAlt size={50} color="#FFF" />,
  },
  { name: "Lal Kitab Webinar", icon: <GiNotebook size={50} color="#FFF" /> },
  { name: "Occult Gurukul", icon: <FaBook size={50} color="#FFF" /> },
  { name: "Gemsmantra", icon: <FaGem size={50} color="#FFF" /> },
  {
    name: "Mega Numerology Webinar",
    icon: <GiNotebook size={50} color="#FFF" />,
  },
  {
    name: "Kaal Sarp & Manglik Dosh Report, Fortune Report",
    icon: <GiCrystalBall size={50} color="#FFF" />,
  },
  { name: "Couple Kundali", icon: <FaUsers size={50} color="#FFF" /> },
  { name: "Baby Name Report", icon: <FaBaby size={50} color="#FFF" /> },
  { name: "Buy Gemstones", icon: <FaGem size={50} color="#FFF" /> },
  { name: "Our Courses", icon: <FaBook size={50} color="#FFF" /> },
  { name: "Buy Rudraksha", icon: <FaGem size={50} color="#FFF" /> },
];
const medias = [
  "सकारात्मक परिवर्तन के साथ ही आगे बढ़ा जा सकता हैः पंडित",
  "ज्योतिष और अंकशास्त्र से कैसे होगा आपकी समस्या का समाधान, Astro पंडित ने बताया",
  "Pandit Ji: Bridging Ancient Wisdom With Modern Science",
  "Astro Pandit Unveils 'Main Aisa Kyun Hoon?' – A Revolutionary OTT Series on Astrology",
  "Why 'Main Aisa Kyun Hoon?' OTT Series Is a Must-Watch for Gen Z",
  "Astro Pandit announces a donation drive 'Ramnavmi Daan Maha Abhiyan",
  "JioHotstar पर रिलीज हुई 'मैं ऐसा क्यों हूं' की नई सीरीज, पढ़ें डिटेल्स",
  "Asia's Best Numerologist Online: Astro Pandit Emerges As A Guiding Light In Numerology",
];
const calculatorImages = {
  "Free Panchang": "https://cdn-icons-png.flaticon.com/512/747/747376.png",
  "Free Nakshatra": "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
  "Free Kundali Matching":
    "https://cdn-icons-png.flaticon.com/512/2913/2913587.png",
  "Free Moon Sign": "https://cdn-icons-png.flaticon.com/512/747/747376.png",
};

const freeCalculators = [
  "Free Panchang",
  "Free Nakshatra",
  "Free Kundali Matching",
  "Free Moon Sign",
];
const Courses = [
  "Advanced Astrology Course",
  "Advanced Numerology Course",
  "Lal Kitab Course",
];
const testimonials = [
  {
    name: "John Doe",
    feedback: "Astro Pandit changed my life. Accurate predictions!",
  },
  {
    name: "Priya Sharma",
    feedback: "Great experience with numerology sessions.",
  },
  {
    name: "Amit Verma",
    feedback: "His consultation gave me clarity in career decisions.",
  },
  {
    name: "Neha Gupta",
    feedback: "The Kundli matching was very helpful for my marriage.",
  },
  {
    name: "Rahul Mehta",
    feedback: "Very professional and insightful guidance.",
  },
  { name: "Anjali Singh", feedback: "Loved the personalized kundli report!" },
  { name: "Vikram Kapoor", feedback: "Practical remedies that actually work." },
  {
    name: "Sneha Joshi",
    feedback: "Highly recommended for astrology & numerology.",
  },
];
const chunkArray = (arr, size) =>
  arr.reduce(
    (acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]),
    []
  );

const faqs = [
  {
    question: "What services do you provide?",
    answer:
      "We provide astrology, numerology, palmistry, and personalized consultation services.",
  },
  {
    question: "How can I book a consultation?",
    answer:
      "You can book directly from our website under the 'Book Consultation Call' section.",
  },
  {
    question: "Do you provide online courses?",
    answer:
      "Yes, we offer both beginner and advanced courses in Astrology and Numerology.",
  },
  {
    question: "Can I collaborate with you?",
    answer: "Of course! Visit our 'Collaborate With Us' page to get started.",
  },
];
export default function Home() {
  useTitle("Home | Astro Portal");
  const [showDropdown, setShowDropdown] = useState({});
  const [openIndex, setOpenIndex] = useState(null);
  const handleMouseEnter = (menu) => {
    setShowDropdown((prev) => ({ ...prev, [menu]: true }));
  };
  const handleMouseLeave = (menu) => {
    setShowDropdown((prev) => ({ ...prev, [menu]: false }));
  };

  const testimonialChunks = chunkArray(testimonials, 4);
  const Counter = ({ target, suffix }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      let start = 0;
      const duration = 2000; // 2 sec
      const stepTime = Math.abs(Math.floor(duration / target));
      const timer = setInterval(() => {
        start += 1;
        setCount(start);
        if (start >= target) clearInterval(timer);
      }, stepTime);
      return () => clearInterval(timer);
    }, [target]);

    return (
      <h2 className="text-4xl font-bold text-orange-500">
        {count}
        {suffix}
      </h2>
    );
  };
  console.log(localStorage);
  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <>
      {/* Header Banner (Carousel) */}
      <Carousel>
        <Carousel.Item>
          <div className="banner-size">
            <img
              className="img-fluid"
              src="./images/banner_1.jpg"
              alt="First slide"
            />
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="banner-size">
            <img
              className="img-fluid"
              src="./images/banner_2.jpg"
              alt="Second slide"
            />
          </div>
        </Carousel.Item>
      </Carousel>

      {/* Services Section */}
      {/* Products Section */}
      <section id="products" className="py-5" style={{ background: "#fafafa" }}>
        <Container>
          <div className="w-100 text-center mb-5">
            <h2 className="fw-bold text-primary d-inline-block position-relative">
              Our Services
            </h2>
            <div className="astro-divider">
              <span className="astro-line"></span>
              <span className="astro-icon">✦</span>
              <span className="astro-line"></span>
            </div>
            <p className="text-secondary mt-3">
              Explore our trusted spiritual services crafted to bring positivity
              & prosperity.
            </p>
          </div>

          <Row>
            {products.map((product, i) => (
              <Col md={3} sm={6} xs={12} className="mb-4" key={i}>
                <motion.div
                  whileHover={{ scale: 1.05, y: -5 }}
                  transition={{ duration: 0.3 }}
                >
                  <Card
                    className="h-100 text-center border-0 shadow-lg rounded-4"
                    style={{
                      background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
                      boxShadow: "8px 8px 16px #c9c9c9, -8px -8px 16px #ffffff",
                    }}
                  >
                    <div
                      className="circle-image mx-auto mt-4 p-4 rounded-circle shadow-sm"
                      style={{
                        background: "linear-gradient(145deg, #ff9966, #ff5e62)",
                        color: "#fff",
                        width: "110px",
                        height: "110px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {product.icon}
                    </div>
                    <Card.Body>
                      <Card.Title className="mt-3 fw-bold text-dark">
                        {product.name}
                      </Card.Title>
                      <Card.Text className="text-secondary small">
                        Authentic {product.name.toLowerCase()} to bring
                        positivity and prosperity.
                      </Card.Text>
                      <motion.button
                        whileHover={{
                          background:
                            "linear-gradient(145deg, #ff9966, #ff5e62)",
                          color: "#fff",
                        }}
                        whileTap={{ scale: 0.95 }}
                        className="btn fw-bold rounded-pill mt-2 text-danger px-4 border-gradient"
                      >
                        Order Now
                      </motion.button>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Media Section */}
      <section id="media" className="py-5" style={{ background: "#fff" }}>
        <Container>
          <div className="w-100 text-center mb-5">
            <h2 className="fw-bold text-primary d-inline-block position-relative">
              In The Media
            </h2>
            <div className="astro-divider">
              <span className="astro-line"></span>
              <span className="astro-icon">✦</span>
              <span className="astro-line"></span>
            </div>
            <p className="text-secondary mt-3">
              Featured across top media platforms & trusted worldwide.
            </p>
          </div>

          <Row>
            {medias.map((media, i) => (
              <Col md={3} sm={6} xs={12} className="mb-4" key={i}>
                <motion.div
                  whileHover={{ scale: 1.05, y: -5 }}
                  transition={{ duration: 0.3 }}
                >
                  <Card
                    className="h-100 text-center border-0 shadow-lg rounded-4"
                    style={{
                      background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
                      boxShadow: "8px 8px 16px #c9c9c9, -8px -8px 16px #ffffff",
                    }}
                  >
                    <div className="mx-auto mt-4 overflow-hidden rounded-4 shadow-sm">
                      <img
                        src={`#`}
                        alt={media}
                        className="img-fluid w-100 h-100 object-fit-cover"
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                    <Card.Body>
                      <Card.Title className="mt-3 fw-bold text-dark">
                        {media}
                      </Card.Title>
                      <motion.button
                        whileHover={{
                          background:
                            "linear-gradient(145deg, #ff9966, #ff5e62)",
                          color: "#fff",
                        }}
                        whileTap={{ scale: 0.95 }}
                        className="btn fw-bold text-danger rounded-pill mt-2 px-4 fs-6 border-gradient"
                      >
                        Read More
                      </motion.button>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* About Section */}
      <section className="py-5" style={{ background: "#f3e8ff" }}>
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center mb-4 mb-md-0">
              <img
                src="./images/about_us.jpg"
                alt="About Us"
                className="img-fluid rounded shadow-lg about-image"
              />
            </Col>

            <Col md={6}>
              <h2 className="fw-bold mb-3 text-primary">
                Astrology: Your Guide To Life's Journey & Path To Success!
              </h2>
              <p className="text-muted mb-3 fs-5">
                We are dedicated to providing authentic astrology services that
                help individuals discover their life’s true potential. Our
                experienced astrologers specialize in Vedic Astrology,
                Numerology, and spiritual guidance to bring positivity, peace,
                and prosperity in your life.
              </p>
              <p className="text-muted mb-3 fs-5">
                With years of trust and excellence, we aim to combine
                traditional knowledge with modern solutions, helping you make
                better decisions for a successful and happy future.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Counter Section */}
      <section
        id="astrologers"
        className="py-5"
        style={{ background: "#d4af37" }}
      >
        <Container>
          <div className="d-flex flex-wrap justify-content-center justify-content-md-between text-center gap-4 py-5">
            {[
              { target: 200, suffix: "k+", label: "Kundli Served" },
              { target: 50, suffix: "+", label: "Years Of Legacy" },
              { target: 50, suffix: "k+", label: "Students Enrolled" },
              { target: 100, suffix: "k+", label: "Consultations Given" },
              { target: 5, suffix: "+", label: "Languages For Reports" },
              {
                target: 20,
                suffix: "+",
                label: "Awards in the Field of Occult",
              },
            ].map((item, i) => (
              <div className="counter-circle text-center" key={i}>
                <span className="counter-number">
                  {item.target}
                  {item.suffix}
                </span>
                <p className="counter-label fw-bold mb-0">{item.label}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Free Calculators Section */}
      <section
        id="free-calculators"
        className="py-5"
        style={{ background: "#f8f9fa" }}
      >
        <Container>
          <div className="w-100 text-center mb-5">
            <h2 className="fw-bold d-inline-block text-primary">
              Free Calculators
            </h2>
            <div className="astro-divider">
              <span className="astro-line"></span>
              <span className="astro-icon">✦</span>
              <span className="astro-line"></span>
            </div>
            <p className="text-secondary mt-2 fs-5">
              Explore our free astrology calculators to gain insights into your
              horoscope, kundali, and predictions.
            </p>
          </div>
          <Row>
            {freeCalculators.map((calculator, i) => (
              <Col md={6} sm={12} className="mb-4" key={i}>
                <Card className="text-center shadow-lg border-0 rounded-4 p-3 hover:scale-105 transition-transform">
                  <Card.Img
                    variant="top"
                    src={calculatorImages[calculator]}
                    alt={calculator}
                    className="mb-3 w-25 h-25 mx-auto"
                  />
                  <Card.Body>
                    <Card.Title className="mt-3 fs-4 text-dark">
                      {calculator}
                    </Card.Title>
                    <p className="text-muted mb-3">
                      With Horoscope, Kundali, And Predictions
                    </p>
                    <motion.button
                      whileHover={{
                        background: "linear-gradient(145deg, #ff9966, #ff5e62)",
                        color: "#fff",
                      }}
                      whileTap={{ scale: 0.95 }}
                      className="btn fw-bold text-danger rounded-pill mt-2 px-4 fs-6 border-gradient"
                    >
                      Get It Now
                    </motion.button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Book Consultation Section */}
      <section className="py-5" style={{ background: "#fff7f0" }}>
        <Container>
          <Row className="align-items-center">
            {/* Left Side - Content */}
            <Col md={7} className="mb-4 mb-md-0">
              <h2 className="fw-bold mb-3 text-primary">
                Book a Consultation Call with the Best Astrologer in India!
              </h2>
              <p className="text-muted mb-4 fs-5 text-justify">
                We believe astrology is a science, and we aim to create a
                positive impact on your life through accurate astrology charts,
                kundali, numerology, palm reading, and face reading. Join our
                community to discover daily guidance and spiritual insights.
              </p>
              <motion.button
                whileHover={{
                  background: "#fff", // background white on hover
                  color: "transparent", // text gradient
                  WebkitBackgroundClip: "text",
                  backgroundImage: "linear-gradient(145deg, #ff9966, #ff5e62)", // gradient text
                  borderWidth: "2px",
                  borderStyle: "solid",
                  borderImage: "linear-gradient(145deg, #ff9966, #ff5e62) 1", // gradient border
                }}
                whileTap={{ scale: 0.95 }}
                className="btn fw-bold rounded-pill mt-2 px-4 fs-6"
                style={{
                  background: "linear-gradient(145deg, #ff9966, #ff5e62)", // normal gradient bg
                  color: "#fff",
                  border: "2px solid transparent",
                }}
              >
                Book Now
              </motion.button>
            </Col>

            {/* Right Side - Image */}
            <Col md={5} className="text-center">
              <img
                src="./images/about_us.jpg"
                alt="Consultation"
                className="img-fluid rounded shadow-lg consultation-img"
                style={{ maxHeight: "400px", objectFit: "cover" }}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Courses Section */}
      <section id="courses" className="py-5 bg-light">
        <Container>
          <div className="text-center mb-5">
            <h2 className="text-primary pb-2 fw-bold">Explore Our Courses</h2>
            <div className="astro-divider">
              <span className="astro-line"></span>
              <span className="astro-icon">✦</span>
              <span className="astro-line"></span>
            </div>
            <p className="text-muted fs-6">
              Learn from expert astrologers and get certified. Enhance your
              skills today!
            </p>
          </div>

          <Row className="g-4 justify-content-center">
            {Courses.map((course, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="h-100 shadow-lg rounded-4 course-card border-0 hover:shadow-xl transition-shadow">
                  <div className="overflow-hidden rounded-top-4">
                    <img
                      src={`./images/course_${i + 1}.jpg`}
                      alt={course.title || course}
                      className="img-fluid w-100 hover:scale-105 transition-transform"
                      style={{ maxHeight: "200px", objectFit: "cover" }}
                    />
                  </div>
                  <Card.Body className="d-flex flex-column">
                    {/* Course Info */}
                    <div className="mb-3">
                      <h5 className="fw-bold text-danger mb-2">
                        {course.title || course}
                      </h5>
                      <div className="d-flex justify-content-between text-muted fs-7">
                        <div className="d-flex align-items-center">
                          <FaEnvelope className="me-1" /> Certified
                        </div>
                        <div className="d-flex align-items-center">
                          <FaUser className="me-1" /> 500+ Students
                        </div>
                      </div>
                    </div>

                    {/* Enroll Button */}
                    <div className="mt-auto text-center">
                      <motion.button
                        whileHover={{
                          background:
                            "linear-gradient(145deg, #ff9966, #ff5e62)",
                          color: "#fff",
                        }}
                        whileTap={{ scale: 0.95 }}
                        className="btn fw-bold text-danger rounded-pill mt-2 px-4 fs-6 border-gradient"
                      >
                        Read More
                      </motion.button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Counter Section */}
      <section
        id="astrologers"
        className="py-5 text-white"
        style={{ background: "linear-gradient(145deg, #ff9966, #ff5e62)" }}
      >
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-3">Why Choose Us?</h2>
            <p className="fs-6 text-light">
              Trusted by thousands, we provide authentic astrology services and
              products.
            </p>
          </div>

          <div className="row g-4 justify-content-center text-center">
            {[
              { icon: <FaUserShield size={60} />, label: "Licensed Guide" },
              { icon: <FaGem size={60} />, label: "Gemstone Activation" },
              {
                icon: <FaCheckCircle size={60} />,
                label: "Authentic Products",
              },
              { icon: <FaTags size={60} />, label: "Best Pricing" },
              { icon: <FaStar size={60} />, label: "Astrologically Verified" },
              {
                icon: <FaBoxes size={60} />,
                label: "Wide Variety Of Products",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="col-6 col-md-4 col-lg-2 d-flex flex-column align-items-center"
              >
                <div className="counter-circle d-flex align-items-center justify-content-center mb-2 shadow-sm rounded-circle bg-white">
                  <div className="text-danger">{item.icon}</div>
                </div>
                <p className="fs-6 fw-bold text-white text-center">
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="py-5 bg-light text-center">
        <div className="container">
          <h2 className="fw-bold text-primary mb-3">
            Know What Your Zodiac Sign Says About You
          </h2>
          <div className="astro-divider">
            <span className="astro-line"></span>
            <span className="astro-icon">✦</span>
            <span className="astro-line"></span>
          </div>
          <p className="mb-5 text-muted fs-6">
            Click on the Rashi to know about your Personality, Traits, Life
            Predictions, and Remedies!
          </p>

          <div className="row g-4 justify-content-center">
            {[
              { icon: <GiAries size={40} />, label: "Aries" },
              { icon: <GiTaurus size={40} />, label: "Taurus" },
              { icon: <GiGemini size={40} />, label: "Gemini" },
              { icon: <GiCancer size={40} />, label: "Cancer" },
              { icon: <GiLeo size={40} />, label: "Leo" },
              { icon: <GiVirgo size={40} />, label: "Virgo" },
              { icon: <GiLibra size={40} />, label: "Libra" },
              { icon: <GiScorpio size={40} />, label: "Scorpio" },
              { icon: <GiSagittarius size={40} />, label: "Sagittarius" },
              { icon: <GiCapricorn size={40} />, label: "Capricorn" },
              { icon: <GiAquarius size={40} />, label: "Aquarius" },
              { icon: <GiPisces size={40} />, label: "Pisces" },
            ].map((sign, idx) => (
              <div
                key={idx}
                className="col-6 col-sm-4 col-md-2 d-flex flex-column align-items-center zodiac-card p-3 rounded-4 shadow-sm bg-white hover:shadow-lg transition-shadow"
              >
                <div className="text-danger mb-2">{sign.icon}</div>
                <p className="mb-0 fw-semibold">{sign.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="bg-light py-5">
        <div className="container text-center">
          <h2 className="text-primary">What Our Clients Say</h2>
          <div className="astro-divider mb-3">
            <span className="astro-line"></span>
            <span className="astro-icon">✦</span>
            <span className="astro-line"></span>
          </div>
          <Carousel indicators={false} interval={4000}>
            {testimonialChunks.map((group, idx) => (
              <Carousel.Item key={idx}>
                <div className="row g-4 p-5 justify-content-center">
                  {group.map((t, i) => (
                    <div className="col-12 col-md-6 col-lg-3" key={i}>
                      <div className="p-4 bg-white rounded-4 shadow-lg  h-100 testimonial-card position-relative">
                        <p className="fst-italic mb-3">"{t.feedback}"</p>
                        <h6 className="fw-bold text-danger">{t.name}</h6>
                        <div
                          className="position-absolute translate-middle-x mb-3"
                          style={{ left: "25%", bottom: "14%" }}
                        >
                          <FaQuoteLeft
                            className="text-danger opacity-25"
                            size={15}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center text-primary fw-bold">
            Frequently Asked Questions
          </h2>
          <div className="astro-divider mb-3">
            <span className="astro-line"></span>
            <span className="astro-icon">✦</span>
            <span className="astro-line"></span>
          </div>
          <div className="accordion">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="mb-3 rounded-4 shadow-sm overflow-hidden border border-gray-200"
              >
                {/* Question Button */}
                <button
                  className="w-100 d-flex justify-content-between align-items-center p-4 bg-white border-0 text-start hover:bg-gray-50 transition-colors"
                  onClick={() => toggleFaq(index)}
                >
                  <span className="fw-semibold fs-6">{faq.question}</span>
                  <FaChevronDown
                    className={`transition-transform duration-300 ${
                      openIndex === index
                        ? "rotate-180 text-maroon"
                        : "text-gray-400"
                    }`}
                  />
                </button>

                {/* Answer */}
                <div
                  className="px-4 overflow-hidden transition-all duration-300"
                  style={{
                    maxHeight: openIndex === index ? "500px" : "0px",
                  }}
                >
                  <p className="py-3 mb-0 text-gray-700">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
